const initializeTopFaqAccordion = () => {
  document.querySelectorAll('.js-top-faq').forEach((container) => {
    const items = Array.from(container.querySelectorAll('.top-faq__item'))

    items.forEach((item) => {
      const button = item.querySelector('.top-faq__question')
      const answer = item.querySelector('.top-faq__answer')
      if (!button || !answer) return

      button.addEventListener('click', () => {
        const isOpen = item.classList.contains('-open')
        item.classList.toggle('-open', !isOpen)
        button.setAttribute('aria-expanded', String(!isOpen))
        answer.hidden = isOpen
      })
    })
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeTopFaqAccordion)
} else {
  initializeTopFaqAccordion()
}
